import { useDispatch } from 'react-redux'
import { NavButton as Button } from 'ui-components'
import { useAuth } from 'user-auth'
import { openMobileNav } from '~map-preview/states/ui'

export function NavButton() {
  const dispatch = useDispatch()
  const { authenticated } = useAuth()

  const handleClick = () => {
    dispatch(openMobileNav())
  }

  if (authenticated) return null

  return <Button onClick={handleClick} />
}
